<template>
    <autocomplete-multi-selector
        v-model="selectedItems"
        placeholder="Buscar pastelerías"
        value-key="name"
        :suggestions="suggestions"/>
</template>

<script>
    import AutocompleteMultiSelector from "../AutocompleteMultiSelector/index";
    import {mapGetters} from 'vuex';
    export default {
        name: "CakeshopAutoMultiSelector",
        components: {AutocompleteMultiSelector},
        props: {
            value: Array,
        },
        computed: {
            ...mapGetters([
                'cakeshops'
            ]),
            selectedItems: {
                get: function() {
                    return this.value;
                },
                set: function(value) {
                    this.$emit('input', value)
                    this.$emit('change')
                }
            }
        },
        mounted() {
            this.$store.dispatch('loadCakeshops');
        },
        methods: {
            suggestions(query, cb) {
                if (query == null) cb([]);
                let results = query
                    ? this.cakeshops.filter((cakeshop) => cakeshop.name.toLowerCase().indexOf(query.toLowerCase()) !== -1)
                    : [];
                cb(results);
            },
        }
    }
</script>